import {
  ModalBuilder,
  Table,
  notifySuccess,
  ActionMenu,
} from "@redriver/cinnamon";
import React from "react";
import { useTranslation } from "react-i18next";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { useDispatch } from "react-redux";
import { setIpsPhysicalApproval } from "./actions";
import { DropdownItem } from "semantic-ui-react";

const SetIpsPhysicalApproval = ({ sheet, onSubmitted }) => {
  const { t } = useTranslation("agreements");
  const dispatch = useDispatch();
  const { sheetId, sheetName } = sheet;

  return (
    <ModalBuilder
      submitAction={setIpsPhysicalApproval}
      submitParams={{ sheetId }}
      onSubmitted={() => {
        dispatch(notifySuccess("Sheet successfully approved"));
        onSubmitted();
      }}
      renderTrigger={(onTrigger) => (
        <DropdownItem onClick={onTrigger}>
          {t("SheetActions.SetIpsPhysicalApproval.TriggerText")}
        </DropdownItem>
      )}
      renderModal={(modalProps) => (
        <TranslatedModal.Confirmation
          {...modalProps}
          header={t("SheetActions.SetIpsPhysicalApproval.ModalHeader")}
        >
          {t("SheetActions.SetIpsPhysicalApproval.ModalContent", { sheetName })}
        </TranslatedModal.Confirmation>
      )}
    />
  );
};

export default SetIpsPhysicalApproval;
